import { render, staticRenderFns } from "./FreelancerMenu.vue?vue&type=template&id=1626936f&"
import script from "./FreelancerMenu.vue?vue&type=script&lang=js&"
export * from "./FreelancerMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports